import React, { useEffect } from 'react'

import ActionsFactory from 'live/components/events/lib/actions'
import StoreFactory from 'live/components/events/lib/store'
import ConsoleFactory from 'live/components/events/ui/console'
import i18n from 'live/services/i18n'

import { RoundedModal } from 'plugin-channelmanager/generic/RoundedModal/RoundedModal'

// import { RoundedModal } from 'plugin-channelmanager/generic'

export interface IUpdatedExpression {
    chart: boolean
    defaultReducer: string
    description: string
    expression: string
    follow: boolean
    preload: boolean
    reducer: string
    reducerType: string
    span: string
}

export const ConsoleModal: React.FC<{
    show: boolean
    onUpdate(config: IUpdatedExpression): void
    onClose(): void
    expression: string
}> = ({ show, onClose, onUpdate, expression }) => {
    const eventStore = StoreFactory('config/datasource-form', {
        enforceDependencies: true
    })

    const eventActions = ActionsFactory('config/datasource-form')
    const Console = ConsoleFactory(eventStore, eventActions, {
        disableUrlMixin: true
    })

    useEffect(() => {
        if (show) {
            eventActions.setExpression(expression)
        }
    }, [show])

    return (
        <RoundedModal show={show} animation={false} className="modal-console" onHide={onClose}>
            <Console
                handles={'e, s, se'}
                minWidth={975}
                maxWidth={document.documentElement.clientWidth - (document.documentElement.clientWidth - 975) / 2 - 15}
                onChange={console.log}
            />
            <RoundedModal.Footer>
                <input
                    type="button"
                    className="btn btn-primary accept"
                    value={i18n('ok')}
                    onClick={() => {
                        onUpdate(eventStore.state().params)
                        onClose()
                    }}
                />
                <span>{i18n('or')}</span>
                <a className="cancel" onClick={onClose}>
                    {i18n('discard')}
                </a>
            </RoundedModal.Footer>
        </RoundedModal>
    )
}
